import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/login',
    name: 'login-page',
    component: require('@/components/LoginPage').default
  },
  {
    path: '/home',
    name: 'home-page',
    component: require('@/components/HomePage').default,
    children: [
      {
        path: '/new-account',
        component: require('@/components/NewAccount').default
      },
      {
        path: '/invoices',
        component: require('@/components/invoices/InvoicesPage').default
      },
      {
        path: '/sms',
        component: require('@/components/sms/SmsPage').default
      },
      {
        path: '/posttoledger',
        component: require('@/components/posttoledger/PostLedgerPage').default
      },
      {
        path: '/assets',
        component: require('@/components/ledger/AssetsPage').default
      },
      {
        path: '/dailyreport',
        component: require('@/components/ledger/DailyReport').default
      },
      {
        path: '/costreport',
        component: require('@/components/ledger/CostReport').default
      },
      {
        path: '/ledgerinvoices',
        component: require('@/components/ledger/LedgerInvoicesPage').default
      },

      {
      path: '/notificationpanel',
        component: require('@/components/Reports/NotificationPanel.vue').default
      },
      {
        path: '/flightsearchreport',
        component: require('@/components/Reports/FlightSearchReport.vue').default
      },
      {
        path: '/refundreport',
        component: require('@/components/Reports/RefundReport').default
      },
      {
      path: '/invoicereport',
        component: require('@/components/Reports/InvoiceReport.vue').default
      },
      
      {
        path: '/inquiries',
        component: require('@/components/inquiries/InquiriesPage').default
      },
      {
        path: '/activitylogs',
        component: require('@/components/activitylogs/ActivityLogsPage').default
      },
      {
        path: '',
        redirect: '/invoices'
      }
    ]
  },
  {
    path: '*',
    redirect: '/home'
  }
]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)
  console.log(authRequired)
  const loggedIn = localStorage.getItem('user')

  if (authRequired && !loggedIn) {
    return next('/login')
  }
  next()
})

export default router
